import { FC } from 'react';

import CustomLoading from 'modules/_shared/components/CustomLoading';

import InformationalModalHeader from './components/InformationalModalHeader';
import InformationalModalBody from './components/InformationalModalBody';
import InformationalModalFooter from './components/InformationalModalFooter';

import { useInformationalModal } from './context/InformationalModalContext';

import '../Modals.scss';

const InformationalModal: FC = () => {
  const { data } = useInformationalModal();

  return (
    <>
      <InformationalModalHeader />
      <InformationalModalBody />
      <InformationalModalFooter />

      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default InformationalModal;
